
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { ScrollArea } from "@/components/ui/scroll-area";
import { UseFormReturn } from "react-hook-form";

interface ProductCheckboxSelectProps {
  form: UseFormReturn<any>;
  products: any[];
}

export function ProductCheckboxSelect({ form, products }: ProductCheckboxSelectProps) {
  const selectedProducts = form.watch("products") || [];

  const handleProductChange = (productName: string, checked: boolean) => {
    let newProducts = [...selectedProducts];
    if (checked) {
      newProducts.push(productName);
    } else {
      newProducts = newProducts.filter(p => p !== productName);
    }
    form.setValue("products", newProducts);
  };

  return (
    <FormField
      control={form.control}
      name="products"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Products</FormLabel>
          <FormControl>
            <ScrollArea className="h-48 w-full border rounded-md p-4">
              <div className="space-y-3">
                {products.map((product) => (
                  <div key={product.id} className="flex items-center space-x-2">
                    <Checkbox
                      id={`product-${product.id}`}
                      checked={selectedProducts.includes(product.name)}
                      onCheckedChange={(checked) => handleProductChange(product.name, checked as boolean)}
                    />
                    <label
                      htmlFor={`product-${product.id}`}
                      className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
                    >
                      {product.name}
                    </label>
                  </div>
                ))}
                {products.length === 0 && (
                  <p className="text-sm text-muted-foreground">No products available</p>
                )}
              </div>
            </ScrollArea>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
